// extracted by css-extract-rspack-plugin
export default {"cell":"JvVRs","row":"INmBd"};